 <template>
    <div class="full-width base-date-picker" role="radiogroup" aria-label="Select date and time for order">
         <p class="has-text-danger">{{msg}}</p>
        <BaseRadio 
            v-if="location.id && !location.locationHours[0].isClosed"
            name="ASAP"
			ref="asapRadio"
			ariaLabel="As soon as possible"
			:aria-checked="(orderTimeKey === 0)"
            :activeClass="(orderTimeKey === 0) ? 'selected' : ''"
            :click="selectASAP"
        >

        <div class="align-right">
            <p class="date-detail"> 
                ~ {{nextAvailableTime.format('MM/DD: ')}} {{ displayDateRange(nextAvailableTime) }} 
            </p>
        </div>

        </BaseRadio>

        <BaseRadio 
            name="Scheduled"
            :activeClass="(orderTimeKey === 1) ? 'selected' : ''"
            :click="() => {orderTimeKey = 1;}"
			ariaLabel="Schedule for later"
			:aria-checked="(orderTimeKey === 1)"
        >

        <div class="align-right">
            <p class="date-detail truncate" v-if="orderTimeKey === 1"> 
                  {{displayDateRange(orderTime) }}
            </p>
            <p class="has-text-grey-light" v-else>
                Pick a Date and Time
            </p>
        </div>

        </BaseRadio>
        <template v-if="orderTimeKey === 1">
            <hr>
            <div @click="orderTimeKey = 1">
                <p class="date-subtitle">Choose Date</p>
                <div id="dates" class="has-text-centered is-flex">
                    <template v-for="(dayObj, index) in week">
                        <div :key="index" 
                             :data-tooltip="(!dayObj.isClosed || dayObj.msg) ? `${dayObj.msg || 'Ordering is disabled for this day'}` : ''"
                             :class="{'tooltip is-tooltip-warning': dayObj.isClosed || dayObj.msg}">
                            <button
                                @click="setDateInFuture(dayObj.day)" 
                                :class="{'is-active': moment(orderTime).isSame(dayObj.day, 'day')}" 
                                class="button is-outlined date-btn date-btn--spacing"
                                :disabled="(dayObj.isClosed) ? true : false"
                                >
                                    {{isMomentToday(dayObj.day) ? 'Today' : dayObj.day.format("ddd")}}
                                    {{dayObj.day.format("D")}}
                           </button>
                        </div>
                    </template>
                    <button
                        id="pick-other"
                        @click="isCalendarOpen = !isCalendarOpen" 
                        class="button is-outlined date-btn date-btn--spacing">
                        Pick Other
                    </button>
                </div>
                <div style="margin-left:10%">
                    <BaseCalendarPicker
                        :isOpen="isCalendarOpen"
                        :config="config" 
                        :positionElement="config.positionElement"
                        @on-change="userSetFutureDate"
                    />
                </div>
                <hr>
                <p class="date-subtitle">Choose {{serviceType === EServiceType.SERVICE_TYPE_TAKEOUT ? 'Pickup' : 'Delivery'}} Time</p>
                <div class = "columns is-multiline is-mobile is-centered is-gapless">
                    <div id="times" class="column is-10-desktop">
                        <div class="columns is-mobile is-multiline is-gapless">
                            <template v-for="(value, index) in getTimes()">
                                <div v-if="!isTimeInPromiseRange(value)" :key="index" class="column is-half is-narrow">
                                    <a
										:href="`/time=${value.format('h:mma')}`"
                                        @click.prevent="selectOrderTime(value)"
                                        :class="{'is-active': orderTime.day() === value.day() && orderTime.hour() === value.hour() && orderTime.minute() === value.minute()}" 
                                        class="button is-fullwidth is-medium date-btn is-outlined is-size-6">
                                            {{(isTimeASAP(value)) ? 'ASAP' : value.format('h:mma') }}
                                    </a>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>


<script>
import * as moment from "moment";
import EventBus from '@EventBus';
import DateManipulator from '@/utils/DateManipulator';
import timeMixin from "@/components/mixins/timeMixin";
import { ACCOUNT_CHECKOUT, LOCATION } from "@/stores/defs";
import { EServiceType } from "@/models/interfaces/Orders/EServiceType";
import { mapGetters, mapActions } from "vuex";
import { ERROR_MSG } from '@/common/messages/error.msg';
import locationsMixin from '@Mixin/locationsMixin';

export function enforceFifteenMinIncrements(dstr, dobjs, fp) {
    setTimeout( () => {
        const d = fp.latestSelectedDateObj || new Date();
        const mins = d.getMinutes();

        if (mins % 15)
            d.setMinutes(15*Math.ceil(d.getMinutes() / 15));
            fp.setDate(d, false);
    }, 500);
}

export default {
	mixins: [
		timeMixin,
		locationsMixin,
	],
    computed: {
        ...mapGetters({
            orderTime: ACCOUNT_CHECKOUT.GET_ORDER_TIME,
            serviceType: ACCOUNT_CHECKOUT.GET_SERVICE_TYPE,
            location: LOCATION.GET_LOCATION
        }),
        getOrderDay() {
            return this.orderTime.format('MM/DD: ')
        }
    },
    data() {
        return {
            isCalendarOpen: false,
            week: [],
            orderTimeKey: 0,
            chosenTime: DateManipulator.roundMomentTo15Min(moment()),
            EServiceType: EServiceType,
            config: {
                positionElement: document.getElementById("dates"),
                minDate: Date.now(),
                maxDate: null,
                minuteIncrement: 15,
                onReady: enforceFifteenMinIncrements,
                onValueUpdate: enforceFifteenMinIncrements,
                disableMobile: "true",
                static: true,
                disable: []
			},
			msg: '',
        };
    },
    mounted() {
		const location = this.location;
		if (this.orderTime) {
            if (!DateManipulator.isTimeASAP(this.chosenTime)) {
                this.orderTimeKey = 1;
            } 
		}
		if (location.locationHours[0].isClosed) {
			this.msg = ERROR_MSG.ORDER.ORDER_TIME.STORE_CLOSED;
		}
		if (location) {
			let todaysHours = location.locationHours[0];
			let startTime = todaysHours.startTime;
			let closingTime = moment(todaysHours.endTime);
			if (!moment.isMoment(startTime)) {
				startTime = moment(startTime);
			}
			this.config.minDate = startTime.toDate();
			let maxStartTime = location.locationHours[location.locationHours.length - 1].startTime;
			if (!moment.isMoment(maxStartTime)) {
				maxStartTime = moment(maxStartTime);
			}
			this.config.maxDate = maxStartTime.toDate();

			location.locationHours.forEach((day) => {
				if (day.isClosed) {
					this.config.disable.push(day.startTime.toDate());
				}
			});
			this.checkLateOrder(startTime, closingTime, this.orderTime);
		}
		if (!this.orderTime) {
			const now = moment();
			this.setOrderTime(now);
		}
		this.generateWeek(this.orderTime);
    },
    methods: {
        isMomentToday: DateManipulator.isMomentToday,  
		isTimeASAP: DateManipulator.isTimeASAP,
		checkLateOrder(openingTime, closingTime, orderTime) {
			const now = moment();
			if (closingTime < orderTime || now < openingTime) {
				EventBus.$emit('future-date-only');
				this.orderTimeKey = 1;
				this.hideASAP();
			}
		},
		hideASAP() {
			const asapRadio = this.$refs['asapRadio'];
			asapRadio.$el.style.display = 'none';
		},
        generateWeek(day) {
            this.week = [];
            for (let i = 0; i < 4; i++) {
                const dayOfWeek = moment(day).add(i, "days");
                const daysHours = this.location.getDaysHours(dayOfWeek);
                
                if (!daysHours) {
                    this.week.push({day: dayOfWeek, isClosed: false, msg: ''});
                } else {
                    this.week.push({day: dayOfWeek, isClosed: daysHours.isClosed, msg: daysHours.msg})
                }
            }
        },
        ...mapActions({
            setOrderTime: ACCOUNT_CHECKOUT.SET_ORDER_TIME
		}),
		selectASAP() {
			this.orderTimeKey = 0;
			this.selectOrderTime(this.nextAvailableTime);
			this.$router.push({hash: ''});
		},
		selectOrderTime(value) {
			this.setOrderTime(value);
			this.$tpa.trackCheckoutSchedule(value);
		},
        getTimes() {
            let times = [];

            const generate15MinIncrements = (startTime, closeTime) => {
                let incrementedTime = moment(startTime);
                while (incrementedTime.isBefore(closeTime)) {
                    if (!times.length) {
                        times.push(startTime);
                    } else {
                        incrementedTime.add(15, "minutes");
                        // while incremeneted time less than close and not in promise period (unnecessary dates)
                        if (incrementedTime.isSameOrBefore(closeTime) 
                        && (startTime.isSameOrBefore(incrementedTime))) {
                            times.push(moment(incrementedTime).set({seconds: 0, milliseconds: 0}));
                        } 
                    }
                }
            };

            const now = DateManipulator.roundMomentTo15Min(moment());
            // set to now if time is in past or doesn't exist
            if (!this.orderTime || DateManipulator.roundMomentTo15Min(moment(this.orderTime)).isBefore(now) || this.location.getDaysHours(this.orderTime).isClosed) {
                this.setOrderTime(this.nextAvailableTime);
            } 

            if (DateManipulator.isMomentToday(this.orderTime)) {
                // make sure date is between the store open hours
                const openTime = this.location.locationHours[0].startTime;
                const closeTime = this.location.locationHours[0].endTime;
                let currentTime = moment().set({"second": 0, "millisecond": 0});
                let maxDate = null;

                if (currentTime.isBefore(openTime)) {
                    maxDate = moment(openTime).add(this.calculatedPromiseTime, 'minutes');
                } else {
                    maxDate = currentTime;
                }
                maxDate = DateManipulator.roundMomentTo15Min(maxDate);
                if (currentTime.isBefore(closeTime)) {
                    generate15MinIncrements(maxDate, closeTime);
                }
            } else {
                // generate hours for days that aren't today
                const daysHours = this.location.getDaysHours(this.orderTime);
                const openTime = moment(daysHours.startTime).add(this.calculatedPromiseTime, 'minutes');
                const closeTime = daysHours.endTime;
                                               
                generate15MinIncrements(openTime, closeTime);
            }
            return times;
        },
        userSetFutureDate(val) {
            // user set a date in the future, set first available time
            this.isCalendarOpen = false;
            this.setDateInFuture(val)
            this.generateWeek(this.orderTime);
        },
        setDateInFuture(val) {
            const momentTime = moment(val);
            const daysHours = this.location.getDaysHours(momentTime);
            // check if date is today, if so? only get hours from now/start time till close
            if (DateManipulator.isMomentToday(momentTime)) {
                const currentTime = moment();
                const maxTime = DateManipulator.roundMomentTo15Min(moment.max(currentTime, daysHours.startTime));

                this.setOrderTime(maxTime);
            } else {
                this.setOrderTime(DateManipulator.roundMomentTo15Min(momentTime));
            }
        }

    },
    watch: {
        chosenTime: {
            handler(newValue, oldValue) {
                this.setOrderTime(newValue);
                
            },
            deep: true
        },
        serviceType: {
            handler(newValue, oldValue) {
                this.setOrderTime(this.nextAvailableTime);
            },
        }
    }
};
</script>

<style lang="scss" scoped>
@import "globalStyles";
#times {
    max-height: 20em;
    overflow-y: scroll !important;
    padding-right: 0.1em !important;
}

#times::-webkit-scrollbar {
    width: 5px;
    background-color: #dbdbdb;
    border-radius: 45px;
}

#times::-webkit-scrollbar-thumb {
    background: #aaa;
    border-radius: 45px;
}

.date-btn {
     white-space: normal;
     padding: 1.5em 1em;
}

.is-active {
    border: 1px solid $navigationItemColor !important;
    color: $navigationItemColor !important;
}

.date-subtitle {
    padding-bottom: 0.5em;
}

.radio-button-container .date-detail {
    font-weight: 400;
    max-width: 205px;
}

.date-btn.button {
    margin-right: 0.2em;
    line-height: 0em;
}

.date-btn.button::after, .date-btn.button::before {
    line-height: 1.2em;
    opacity: 1 !important;
}

.date-btn.button.date-btn--spacing {
	padding-top: 0.5em;
	line-height: 1em;
	height: 3em;
}

@include desktop {
	.date-btn.button.date-btn--spacing {
		padding-top: 0.9em;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/common/BaseDatePicker.vue